module.exports = __webpack_public_path__ + "static/media/conversation-speech-bubbles.ea17ed7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/conversation-speech-bubbles.svg
// module id = 463
// module chunks = 0